const MIN_TOKEN_LEN = 2;

export function stripMarkdownToPlainText(md) {
	if (!md || !md.trim()) return "";

	return md
		.replace(/\r\n/g, "\n")
		.replace(/```[\s\S]*?```/g, " ")
		.replace(/`([^`]+)`/g, "$1")
		.replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1")
		.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
		.replace(/^#{1,6}\s+/gm, "")
		.replace(/[*_~]+/g, "")
		.replace(/\\([*_\-[\]()])/g, "$1")
		.replace(/<[^>]+>/g, " ")
		.replace(/\s+/g, " ")
		.trim();
}

export function tokenizeWords(text) {
	if (!text || !text.trim()) return [];

	return text
		.toLowerCase()
		.split(/\s+/)
		.map((token) => token.replace(/^[^\w]+|[^\w]+$/g, ""))
		.filter((token) => token.length >= MIN_TOKEN_LEN);
}

export function computeMissingWords(aiMd, humanIdleMd) {
	const aiTokens = tokenizeWords(stripMarkdownToPlainText(aiMd));
	const idleTokens = tokenizeWords(stripMarkdownToPlainText(humanIdleMd));

	const aiCounts = new Map();
	for (const token of aiTokens) {
		aiCounts.set(token, (aiCounts.get(token) ?? 0) + 1);
	}

	let missing = 0;
	for (const token of idleTokens) {
		const remaining = aiCounts.get(token) ?? 0;
		if (remaining > 0) {
			aiCounts.set(token, remaining - 1);
		} else {
			missing += 1;
		}
	}

	return missing;
}

export function computeContentVisibilityPct(aiMd, humanIdleMd) {
	const idleTokens = tokenizeWords(stripMarkdownToPlainText(humanIdleMd));
	if (idleTokens.length === 0) return 100;

	const missing = computeMissingWords(aiMd, humanIdleMd);
	return Math.round(((idleTokens.length - missing) / idleTokens.length) * 100);
}

export function getVisibilitySublabel(pct) {
	if (pct >= 90) return "Good visibility with room for improvement";
	if (pct >= 70) return "Moderate visibility — review JS-dependent content";
	return "Low visibility — significant content hidden from AI";
}
